// Bouton "Filtrer" pour ouvrir les filtres en version mobile
const filtersToggler = document.getElementById('toggle-appels-filters');
const categoryTree = document.getElementById('appels-filter');

if (typeof(filtersToggler) != 'undefined' && filtersToggler != null) {
  filtersToggler.addEventListener('click', () => {
    const isActive = filtersToggler.classList.contains('active');

    // Ouvrir celui cliqué
    if (!isActive) {
      filtersToggler.classList.add('active');
      filtersToggler.setAttribute('aria-expanded', 'true');
      categoryTree.classList.add('filters--opened')
    } else {
      filtersToggler.classList.remove('active');
      filtersToggler.setAttribute('aria-expanded', 'false');
      categoryTree.classList.remove('filters--opened')
    }
  });
}

const form = document.getElementById('filter-appel-projet');

if (form) {
  form.addEventListener('submit', (e) => {
    e.preventDefault();

    const params = new URLSearchParams();

    const territoire = [...form.querySelectorAll('input[name="filter-territoire"]:checked')]
      .map(i => i.value)
      .join(',');
    if (territoire) params.set('filter-territoire', territoire);

    const typologie = [...form.querySelectorAll('input[name="filter-typologie"]:checked')]
      .map(i => i.value)
      .join(',');
    if (typologie) params.set('filter-typologie', typologie);

    const financeur = [...form.querySelectorAll('input[name="filter-financeur"]:checked')]
      .map(i => i.value)
      .join(',');
    if (financeur) params.set('filter-financeur', financeur);

    const france = [...form.querySelectorAll('input[name="filter-france"]:checked')]
      .map(i => i.value)
      .join(',');
    if (france) params.set('filter-france', france);

    const action = form.getAttribute('action') || window.location.pathname;
    window.location.href = `${action.split('?')[0]}?${params.toString()}`;
  });
}
